// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"a867960d","197":"8b270b17","725":"2ceb2e2f"}[chunkId] + ".chunk.js";
};